"use client";

import { useEffect, useState, useRef } from "react";


interface ProcessStep {
  id: string;
  number: string;
  title: string;
  description: string;
  icon: string;
  time: string;
}

const ProcessFlow = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const steps: ProcessStep[] = [
    {
      id: "step_inquiry",
      number: "01",
      title: "Submit Inquiry",
      description: "Share your commodity requirements and quantities through our platform or contact our team directly",
      icon: "DocumentTextIcon",
      time: "2-hour response",
    },
    {
      id: "step_quote",
      number: "02",
      title: "Get Live Quote",
      description: "Receive transparent pricing based on real-time market data with no hidden fees",
      icon: "CurrencyDollarIcon",
      time: "Instant pricing",
    },
    {
      id: "step_order",
      number: "03",
      title: "Confirm Order",
      description: "Review terms, quality specs, and delivery timeline. Digital contracts for quick processing",
      icon: "DocumentCheckIcon",
      time: "Same-day contract",
    },
    {
      id: "step_track",
      number: "04",
      title: "Track Shipment",
      description: "Monitor your order from warehouse to delivery with real-time GPS tracking and updates",
      icon: "TruckIcon",
      time: "Live tracking",
    },
  ];

  return (
    <section data-component-id="src/app/homepage/components/ProcessFlow.tsx:72:4" data-component-path="src/app/homepage/components/ProcessFlow.tsx" data-component-line="72" data-component-end-line="88" data-component-file="ProcessFlow.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-24%20bg-background%20relative%20overflow-hidden%22%7D"
      ref={sectionRef}
      className="py-24 bg-background relative overflow-hidden"
    >
      {/* Background Pattern */}
      <div data-component-id="src/app/homepage/components/ProcessFlow.tsx:77:6" data-component-path="src/app/homepage/components/ProcessFlow.tsx" data-component-line="77" data-component-end-line="83" data-component-file="ProcessFlow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20opacity-%5B0.02%5D%22%7D"
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `radial-gradient(circle, rgba(13, 115, 124, 0.3) 1px, transparent 1px)`,
          backgroundSize: "30px 30px",
        }}
      />

      <div data-component-id="src/app/homepage/components/ProcessFlow.tsx:85:6" data-component-path="src/app/homepage/components/ProcessFlow.tsx" data-component-line="85" data-component-end-line="87" data-component-file="ProcessFlow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container-custom%20relative%20z-10%22%7D" className="container-custom relative z-10">
        {/* Process Steps */}
      </div>
    </section>
  );
};

export default ProcessFlow;